import Navbar from "../components/Navbar";
import HeroHome from "../components/HeroHome";
import HomePart from "../components/HomePart";
import Footer from '../components/Footer';

/**
import Spline from '@splinetool/react-spline';

export default function App() {
  return (
    <Spline scene="https://prod.spline.design/b8EBdCxUvRIcjNTu/scene.splinecode" />
  );
}
**/

function Home(){
    return(
        <>
            <Navbar/>
            <HeroHome
                cName="hero-homepage-container" 
                title="CAR-Ma" 
                text="Advancing the frontier of cancer immunotherapy"
                goldText="🏅We got Gold Medal!!🏅"
                btnText="Learn more" url="/hku-hongkong/description" btnClass="show"
            
                /**spline="https://static.igem.wiki/teams/4696/wiki/macrophage-3-0real.gltf"*/
            />
            <HomePart/>
            <Footer/>
        </>
    )
}

export default Home;
